// 交付短链后台 API（delivery 短链升级）：创建交付详情，返回随机短 ID。
// 单独成文件以避免 deliveryApi ←→ adminAuth 循环依赖（与 bookingApi 同思路）。
import { getDeliveryApiBase } from "./deliveryApi";
import { getAdminToken } from "./adminAuth";

export async function createDelivery({
    albumPath,
    albumName,
    expiry,
    consent,
    type,
    downloadAllType,
    downloadAllToken,
    archiveMarkdown,
}) {
    const base = getDeliveryApiBase();
    if (!base) {
        throw new Error("MISSING_API");
    }
    const token = getAdminToken();
    const response = await fetch(`${base}/api/delivery/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            albumPath,
            albumName,
            expiry,
            consent,
            type,
            downloadAllType,
            downloadAllToken,
            archiveMarkdown,
        }),
    });
    if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        const error = new Error(body.error?.message || "REQUEST_FAILED");
        error.status = response.status;
        throw error;
    }
    const data = await response.json();
    return data.delivery;
}

export async function updateDelivery(
    id,
    {
        albumPath,
        albumName,
        expiry,
        consent,
        type,
        downloadAllType,
        downloadAllToken,
        archiveMarkdown,
    }
) {
    const base = getDeliveryApiBase();
    if (!base) {
        throw new Error("MISSING_API");
    }
    const token = getAdminToken();
    const response = await fetch(`${base}/api/delivery/${encodeURIComponent(id)}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            albumPath,
            albumName,
            expiry,
            consent,
            type,
            downloadAllType,
            downloadAllToken,
            archiveMarkdown,
        }),
    });
    if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        const error = new Error(body.error?.message || "REQUEST_FAILED");
        error.status = response.status;
        throw error;
    }
    return true;
}

export async function listDeliveries() {
    const base = getDeliveryApiBase();
    if (!base) {
        throw new Error("MISSING_API");
    }
    const token = getAdminToken();
    const response = await fetch(`${base}/api/deliveries`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        const error = new Error(body.error?.message || "REQUEST_FAILED");
        error.status = response.status;
        throw error;
    }
    const data = await response.json();
    return data.deliveries || [];
}

export async function deleteDelivery(id) {
    const base = getDeliveryApiBase();
    if (!base) {
        throw new Error("MISSING_API");
    }
    const token = getAdminToken();
    const response = await fetch(`${base}/api/delivery/${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        const error = new Error(body.error?.message || "REQUEST_FAILED");
        error.status = response.status;
        throw error;
    }
    return true;
}
